// Sentry must be initialized before any other imports
import * as Sentry from "@sentry/react";
import { router } from "./router";

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
    tracesSampleRate: import.meta.env.DEV ? 1.0 : 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracePropagationTargets: [/^\//, /^https:\/\/writ\.misplot\.com/],
    integrations: [
      Sentry.tanstackRouterBrowserTracingIntegration(router),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: true,
        blockAllMedia: false,
      }),
    ],
  });
}

import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { PostHogProvider } from "@posthog/react";
import "@fontsource-variable/rubik";
import "./globals.css";

// --- Render ---
const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN;
const posthogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com",
  defaults: "2026-01-30",
} as const;

const app = posthogKey ? (
  <PostHogProvider apiKey={posthogKey} options={posthogOptions}>
    <RouterProvider router={router} />
  </PostHogProvider>
) : (
  <RouterProvider router={router} />
);

const rootElement = document.getElementById("root")!;

// React 19 error hooks — Sentry captures errors at the React level
ReactDOM.createRoot(rootElement, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error", error, errorInfo.componentStack);
  }),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(<React.StrictMode>{app}</React.StrictMode>);
